import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import React, { Component } from "react";
import * as RVApi from "../../api/api";
import { RVDocumentLookup, RVLookupX } from "../../api/api";
import RVContext from "../../RVContext";
import { getDocIdForUser, updateRVDocs } from "../../RVUtils";
import { hideLoading, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import Strings from "@my-dld/assets/strings";
import { Property, RVDocument, RVDocumentPage } from "../../api/Property";
import { ErrorContainer } from "@eres/forms";
import DocumentInputField from "@my-dld/components/Form/DocumentInputField";
import Dropzone from "react-dropzone";
import { LocaleUtil, StringUtil } from "@eres/core";
import { navigateWithInParent } from "@my-dld/utils/StoreUtils";

interface Props extends RoutedViewProps {
}

interface LookupState {
	Reasons?: RVLookupX[];
	Documents?: RVDocumentLookup[];
	pages: RVDocumentPage[];
}

interface State extends LookupState {
	errorContainer: ErrorContainer;
}

class RVDocuments extends Component<Props, State> {
	static contextType = RVContext;
	context!: React.ContextType<typeof RVContext>;
	docRefs: DocumentItem[] | null[] = [];

	constructor( props: Props ) {
		super( props );
		this.state = {
			errorContainer: {},
			pages: [],
		};
	}

	componentDidMount() {
		this.loadLookup( "RVAttachments", "Documents", getDocIdForUser( this.context.env ) + "" );
	}

	loadLookup( key: string, stateKey: keyof LookupState, parm1: string = "", param2: string = "" ) {
		showLoading();
		RVApi.loadLookupsX( key, parm1, param2 )
		.then( RVApi.validateResponseX ).then( value => {
			hideLoading();
			const update: Partial<State> = {};
			update[ stateKey ] = value as any;
			this.setState( update as State );
		} ).catch( () => {
			hideLoading();
		} );
	}

	render() {
		const { errorContainer, Documents } = this.state;
		const lookup = Documents && Documents.length > 0 ? Documents[ 0 ] : undefined;
		const maxSizeKb = lookup ? lookup.MaxSizeKb ? ( lookup.MaxSizeKb * 1000 ) : ( 2 * 1024 * 1000 ) : undefined;
		return <React.Fragment>
			{ this.state.Documents && this.state.Documents.length > 0 &&
				<div className="card mb-3">
					<div className="card-header">
						<span> { Strings.documents } </span>
					</div>
					<div className="card-body">
						<div className="row doc-grid-margin">
							{
								lookup && maxSizeKb &&
								<div className="col-12 mb-4">
									<small>{ Strings.upload_documents_note.replace( "~", maxSizeKb + "" ) }</small>
								</div>
							}
							{ this.state.Documents.map( ( doc, index ) => {
								let currentData: RVDocumentPage[] = [];
								if ( this.context.documents ) {
									let ds = this.context.documents.find( x => x.lookupId === doc.Identity );
									if ( ds ) {
										currentData = ds.pages;
									}
								}
								return <DocumentItem
									errorContainer={ errorContainer }
									lookup={ doc }
									current={ currentData }
									ref={ ( r ) => {
										this.docRefs[ index ] = r;
									}
									}
								/>;
							} ) }
						</div>
					</div>
				</div>
			}
			<div className="enoc-add-buyer">
				<button
					className="btn btn_1 btn_style1 btn-sm" data-bs-target="#completedProjectsModal"
					onClick={ this.onProceed }
					data-bs-toggle="modal" type="button">
					{ Strings.proceed }
				</button>
			</div>
		</React.Fragment>;
	}

	updateDocs = () => {
		let documents: RVDocument[] = [];
		if ( this.docRefs.length > 0 ) {
			for ( let doc of this.docRefs ) {
				if ( doc ) {
					documents.push( doc.getData() );
				}
			}
		}
		updateRVDocs( documents );
	};

	onProceed = () => {
		if ( this.validateForm() ) {
			this.updateDocs();
			navigateWithInParent( "rentalvaluation", "rvReason" );
		}
	};

	validateForm = () => {
		let isValid = true;
		if ( this.docRefs.length > 0 ) {
			for ( let doc of this.docRefs ) {
				if ( doc ) {
					isValid = doc.validate() && isValid;
				}
			}
		}
		return isValid;
	};
}

export default RVDocuments;

interface DocItemProps {
	lookup: RVDocumentLookup;
	current: RVDocumentPage[];
	errorContainer: ErrorContainer;
	onDocChanged?: Function;
}

interface DocItemState {
	errorContainer: ErrorContainer;
	pages: RVDocumentPage[];
}

export class DocumentItem extends Component<DocItemProps, DocItemState> {
	constructor( props: DocItemProps ) {
		super( props );
		this.state = {
			errorContainer: this.props.errorContainer,
			pages: [ ...this.props.current ],
		};
	}

	render() {
		const { current, lookup, errorContainer } = this.props;
		const { pages } = this.state;
		const isDocsAdded = ( lookup && current !== undefined && current.length > 0 );
		const maxPages = lookup.MaxPages ? lookup.MaxPages : 1;
		const maxSizeKb = lookup.MaxSizeKb ? ( lookup.MaxSizeKb * 1000 ) : ( 2 * 1024 * 1000 );
		return <div key={ `doc_info_${ lookup.Identity }` } className="col-md-8 mb-4">
			<Dropzone
				multiple={ maxPages > 1 }
				maxSize={ maxSizeKb }
				onDropRejected={ this.onDropRejected }
				onDrop={ this.onDrop }
				accept={ [ "image/png", "image/jpeg", "application/pdf" ] }>
				{ ( { getRootProps, getInputProps } ) => (
					<DocumentInputField { ...getRootProps() }
					                    required={ true }
					                    dropZoneInputProps={ getInputProps() }
					                    label={ LocaleUtil.getLocalValue( lookup ) }
					                    isDocsAdded={ isDocsAdded }
					                    error={ errorContainer[ lookup.Identity ] }
					                    disabled={ ( current && current.length === maxPages ) }/>
				) }
			</Dropzone>
			{ pages.map( ( doc: RVDocumentPage ) => {
				return <PageItem page={ doc } onRemove={ this.onRemoveDoc } key={ getPageUrl( doc ) }/>;
			} ) }
		</div>;
	}

	onRemoveDoc = ( page: RVDocumentPage ) => {
		const xu = getPageUrl( page );
		let docs = this.state.pages.filter( ( value ) => getPageUrl( value ) !== xu );
		this.setState( {
			pages: [ ...docs ],
		} );
		if ( this.props.onDocChanged ) {
			this.props.onDocChanged( docs );
		}
	};

	validate = () => {
		const { lookup } = this.props;
		let { pages, errorContainer } = this.state;

		if ( lookup.IsMandatory && pages.length < 1 ) {
			errorContainer[ lookup.Identity ] = Strings.required;
			this.setState( {
				errorContainer: errorContainer,
			} );
			return false;
		}
		return true;
	};

	onDropRejected = () => {
		const { lookup } = this.props;
		let { errorContainer } = this.state;
		errorContainer[ lookup.Identity ] = Strings.required;
		this.setState( {
			errorContainer: errorContainer,
		} );
		showMessage( Strings.tabu_file_exceed_size );
	};
	onDrop = ( files: File[] ) => {
		const { lookup } = this.props;
		const pages = this.state.pages;
		if ( lookup.MaxPages && lookup.MaxPages > 1 ) {
			if ( pages && pages.length > 0 ) {
				let maxAllowed = ( lookup.MaxPages - pages.length );
				if ( files.length > maxAllowed )
					files = files.splice( 0, maxAllowed );
			} else if ( files.length > lookup.MaxPages ) {
				files = files.splice( 0, lookup.MaxPages );
			}
		}
		files.filter( x => x.type.startsWith( "image/" ) || x.type.startsWith( "application/pdf" ) )
		.forEach( file => this.addFile( lookup, file ) );
	};

	addFile = ( lookup: RVDocumentLookup, file: File ) => {
		let docs = this.state.pages;
		if ( lookup.MaxSizeKb ) {
			const max = ( lookup.MaxSizeKb / 1024 ).toFixed( 2 );
			let fSize = -1;
			if ( file.size ) {
				fSize = file.size;
			}
			if ( fSize !== -1 ) {
				if ( fSize / 1024 > lookup.MaxSizeKb ) {
					showMessage( Strings.file_size_not_more.format( [ max ] ) );
					return;
				}
			}

		}
		const reader = new FileReader();
		reader.onload = () => {
			const binaryStr = reader.result;
			docs.push( {
				file: file,
				localUri: binaryStr as string,
				lookupId: lookup.Identity,
			} );
			this.setState( {
				pages: [ ...docs ],
				errorContainer: {},
			} );
			if ( this.props.onDocChanged ) {
				this.props.onDocChanged( docs );
			}
		};
		reader.readAsDataURL( file );
	};

	updateProperty( property: Property ) {
		property.rvData!.documents!.push( this.getData() );
	}

	public getData(): RVDocument {
		return {
			lookupId: this.props.lookup.Identity,
			pages: this.state.pages,
		};
	}

}

enum RVDocTypes {
	IMAGE = "image",
	PDF = "pdf",
}

interface PageItemProps {
	key: string;
	page: RVDocumentPage;
	onRemove: ( page: RVDocumentPage ) => void;
}

interface PageItemState {
	type: "pdf" | "image";
	uri: string;
}

class PageItem extends Component<PageItemProps, PageItemState> {
	constructor( props: PageItemProps ) {
		super( props );
		this.state = {
			type: getPageType( this.props.page ),
			uri: getPageUrl( this.props.page ),
		};
	}

	render() {
		const { page, key } = this.props;
		const { type } = this.state;
		let preview = ( type === RVDocTypes.PDF ) ? <i className="far fa-file-pdf"/> : getImagePreview( this.props.page );
		return <div className={ "mt-3 mb-2" }>
			<table className="table table-bordered table-condensed table-striped table-responsive-sm upload-table">
				<thead>
				<tr>
					<th>{ Strings.file }</th>
					<th>{ Strings.document_name }<span className="asterisk"> *</span></th>
					<th>{ Strings.action }</th>
				</tr>
				</thead>
				<tbody>
				<tr>
					<td>{ preview }</td>
					<td><a
						key={ key }
						onClick={ () => {
							window.open( page.remoteUri );
						} }>
						<i/>{ page.file?.name }</a></td>
					<td>
						<button
							className="btn btn-grey" onClick={ () => {
							if ( this.props.onRemove ) this.props.onRemove( page );
						} }><i className="far fa-trash-alt"/>{ Strings.delete }
						</button>
					</td>
				</tr>
				</tbody>
			</table>
		</div>;
	}
}

function getImagePreview( page: RVDocumentPage ) {
	let source = ( page.localUri && !StringUtil.isEmptyStringOrNull( page.localUri ) ) ?
		page.localUri : page.remoteUri;
	return <img src={ source } style={ { height: 40, width: 40 } } alt={ "uploaded_image" }/>;
}

function getPageUrl( page: RVDocumentPage ): string {
	if ( page.file && !StringUtil.isEmptyStringOrNull( page.file.name ) ) return page.file.name;
	return page.remoteUri!;
}

export function getPageType( page: RVDocumentPage ): RVDocTypes {
	let uri = getPageUrl( page )!;
	if ( uri && uri.toLowerCase().endsWith( ".pdf" ) ) return RVDocTypes.PDF;
	return RVDocTypes.IMAGE;
}

/*
return <RenderUploadDocs
                            lookup={doc}
                            current={currentData}
                            onDrop={this.onDrop}
                            errorContainer={this.state.errorContainer}
                            key={doc.Identity}/>;
 */
